import { FinanceApplication } from "../models/FinanceApplication";
export class FinanceApplicationEmail {
    constructor({
      orderID = 0,
      index=0,
      url='',
      application=new FinanceApplication(),
      comments=''
    } = {}) {
      this.orderID = orderID;
      this.index=index;
      this.url=url;
      this.application=application;
      this.comments=comments;
    }
  }
  
  export function createFinanceApplication(data) {
    return Object.freeze(new FinanceApplicationEmail(data));
  }